import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Home,
  Truck,
  Users,
  UserCheck,
  Phone,
  MapPin,
  Activity,
  Settings
} from 'lucide-react';

const Sidebar = () => {
  const menuItems = [
    { path: '/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/fleet', icon: Truck, label: 'Fleet Management' },
    { path: '/patients', icon: Users, label: 'Patients' },
    { path: '/staff', icon: UserCheck, label: 'Medical Staff' },
    { path: '/emergency-contacts', icon: Phone, label: 'Emergency Contacts' },
    { path: '/tracking', icon: MapPin, label: 'Live Tracking' },
  ];

  return (
    <aside className="w-72 min-h-screen bg-neutral-50 border-r border-neutral-200 flex flex-col font-sans rounded-r-2xl shadow-soft">
      {/* Logo/Header */}
      <div className="flex items-center gap-3 px-8 pt-8 pb-6">
        <div className="w-11 h-11 bg-primary-100 rounded-xl flex items-center justify-center">
          <Activity className="w-6 h-6 text-primary-500" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-neutral-900 tracking-tight">MediFleet</h1>
          <p className="text-xs text-neutral-400 font-medium">Ambulance Service</p>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 px-4 mt-2">
        <ul className="space-y-1">
          {menuItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-full transition-all duration-200 font-medium text-base group
                  ${isActive
                    ? 'bg-primary-100 text-primary-700 shadow-card'
                    : 'text-neutral-600 hover:bg-neutral-100 hover:text-primary-700'}
                  `
                }
              >
                <item.icon className="w-5 h-5 group-hover:text-primary-500 transition-colors duration-200" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Section Divider */}
        <div className="my-6 border-t border-neutral-200"></div>
      </nav>

      {/* Settings/Help Section */}
      <div className="px-8 pb-4">
        <button className="flex items-center gap-3 w-full px-4 py-2 rounded-full text-neutral-500 hover:text-primary-700 hover:bg-neutral-100 transition-all font-medium mb-2">
          <Settings className="w-5 h-5" />
          <span>Settings</span>
        </button>
        <button className="flex items-center gap-3 w-full px-4 py-2 rounded-full text-neutral-500 hover:text-primary-700 hover:bg-neutral-100 transition-all font-medium">
          <span className="w-5 h-5 flex items-center justify-center">
            <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 14h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"></path></svg>
          </span>
          <span>Help</span>
        </button>
      </div>

      {/* User Info Card */}
      <div className="mt-auto px-8 pb-8 pt-2">
        <div className="bg-neutral-100 rounded-xl p-4 flex items-center gap-3 shadow-soft">
          <div className="w-10 h-10 bg-neutral-300 rounded-full"></div>
          <div>
            <p className="text-base font-semibold text-neutral-900 leading-tight">Admin User</p>
            <p className="text-xs text-neutral-500">System Administrator</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar; 